import React from 'react';

import type { RouteMatch } from '@confluence/route/entry-points/Route.ts';
import { CONTAINER_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';
import { FolderRedirectLoader } from '@confluence/folder/entry-points/FolderRedirectLoader.ts';

export const FolderViewRoute = ({ params: { contentId } }: RouteMatch) => (
	<FolderRedirectLoader contentId={contentId} />
);

FolderViewRoute.NAVIGATION_PARAMS = ({
	name: routeName,
	params: { contentId, spaceKey, contentSlug },
}: RouteMatch) => ({
	Screen: {
		screenEvent: {
			name: 'folderScreen',
			id: contentId,
			attributes: {
				contentId,
			},
		},
		pageState: {
			contentId,
			spaceKey,
			contentSlug,
			contentType: 'folder',
			routeName,
		},
	},
	MainLayout: {
		navView: CONTAINER_HOME_ID,
		spaceKey,
		isViewPage: true,
	},
});
